import React from 'react'
import Header from '../../Components/LoginFloder/Header'
import BuilderRequest from '../../Components/Bulider/BuilderRequest'

const BuilderRequestPart = () => {
  return (
    <div>
        <Header />
        <BuilderRequest />
    </div>
  )
}

export default BuilderRequestPart